module.exports = {
    extends: [
        '/',
        'base',
        'bootstrap5',
        'form',
        'form'
    ],

    methods: {
        onResourceSanitized: function(storage){
            // check what fields are granted according to the actual event
            const additionalDataFields = ((((storage.request.event || {}).data || {}).attributes || {}).registrationOptions || {}).additionalDataFields
            if(additionalDataFields){
                for(const fieldCode in additionalDataFields){
                    if(!additionalDataFields[fieldCode]){
                        this.setFieldProperties(fieldCode, {
                            preventTransfer: true,
                            preventRender: true,
                            preventValidation: true
                        })
                    }
                }
            }
        }
    }
}
